import { ButtonProps } from "@mui/material";
import { Play20Px, ProgressButton } from "@qubit/autoparts";
import { parse, stringify } from "qs";

import { useLocation } from "react-router-dom";

import { useFcNavigate } from "~/hooks/useFcNavigate";

type StartPickingNextBatchButtonProps = {
  // this function should clear the state of the previous batch and return the batch ID of the next.
  startBatchCallback: () => Promise<string | null>;
} & ButtonProps;

export const StartPickingNextBatchButton = ({
  startBatchCallback,
  children,
  ...rest
}: StartPickingNextBatchButtonProps) => {
  const navigate = useFcNavigate();
  // probably don't need this but keeping it to reduce the likelihood of regression
  const { search }: { search: string } = useLocation();

  return (
    <ProgressButton
      onClick={async () => {
        const batchId = await startBatchCallback();
        if (batchId === null) {
          // failed to find a valid batch
          return;
        }

        navigate({
          pathname: "/autostore-pick",
          search: stringify({
            ...parse(search, { ignoreQueryPrefix: true }),
            autostore: true,
            batchId: batchId
          })
        });
      }}
      sx={{ textTransform: "none" }}
      buttonSize="xLarge"
      emphasis="high"
      responsive
      variant="contained"
      color="primary"
      startIcon={<Play20Px style={{ fill: "white" }} />}
      fullWidth
      {...rest}
    >
      {children}
    </ProgressButton>
  );
};
